import React from 'react';
import {
  ReferenceManyField,
  Datagrid,
  TextField,
  ReferenceField,
  NumberField,
  DateField,
  useShowController,
  useListContext,
} from 'react-admin';
import { Paper, Typography, makeStyles } from '@material-ui/core';
import EmptyState from './EmptyState';


const CustomDatagridWithEmpty = ({ children, emptyMessage, ...props }) => {
  const { ids, loaded } = useListContext();
  if (!loaded) return null;
  if (!ids || ids.length === 0) {
    return <EmptyState message={emptyMessage} />;
  }
  return <Datagrid {...props}>{children}</Datagrid>;
};

const useStyles = makeStyles(theme => ({
  sectionCard: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
  },
  sectionTitle: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
}));

const UserPurchaseOrdersTab = props => {
  const { record, basePath, resource } = useShowController(props);
  const classes = useStyles();
  if (!record) return null;

  return (
    <Paper className={classes.sectionCard} elevation={1}>
       <Typography variant="h6" className={classes.sectionTitle}>
          Хэрэглэгчийн захиалгууд
        </Typography>
      <ReferenceManyField
        basePath={basePath}
        record={record}
        resource={resource}
        reference="skills/purchaseOrders"
        target="userId"
        sort={{ field: 'createdAt', order: 'DESC' }}
        perPage={25}
      >
        {/*
          Redirect to the PurchaseOrders list view **filtered by the current user**
          instead of opening the individual show page.  This makes it possible
          to browse all of the user’s purchase orders in the dedicated list
          screen.
        */}
        <CustomDatagridWithEmpty
          rowClick={(id, bp, poRecord) => {
            const filter = encodeURIComponent(JSON.stringify({ userId: poRecord.userId }));
            return `/skills/purchaseOrders?filter=${filter}`;
          }}
          emptyMessage="Хэрэглэгчийн захиалга алга байна."
        >
          <TextField source="id" label="ID" />
          <ReferenceField label="Хичээл" source="items.0.courseId" reference="skills/courses" link={false}>
            <TextField source="title" />
          </ReferenceField>
          <NumberField source="items.0.amount" label="Төлбөр" />
          <TextField source="status" label="Статус" />
          <TextField source="tag" label="Төрөл" />
          <DateField source="createdAt" label="Үүсгэсэн" showTime />
        </CustomDatagridWithEmpty>
      </ReferenceManyField>
    </Paper>
  );
};

export default UserPurchaseOrdersTab; 